import { INGESTION_LABEL_MAX, INGESTION_LABEL_MIN, SOURCE_ID_MAX, SOURCE_ID_PATTERN } from '@jums-dashboard/shared';

export function isValidSourceId(value: string): boolean {
  return SOURCE_ID_PATTERN.test(value);
}

export function isValidLabel(value: string): boolean {
  const trimmed = value.trim();
  return trimmed.length >= INGESTION_LABEL_MIN && trimmed.length <= INGESTION_LABEL_MAX;
}

/**
 * Derives a URL-safe slug `sourceId` from a human label. Strips diacritics,
 * lowercases, collapses non-alphanumeric runs into single hyphens, and
 * truncates to {@link SOURCE_ID_MAX} chars. Returns `''` if no usable
 * characters remain.
 */
export function deriveSourceId(label: string): string {
  return label
    .normalize('NFKD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, SOURCE_ID_MAX)
    .replace(/-+$/g, '');
}
